var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-form",
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "sensoryTemplate 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadSensoryTemplateUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "sensoryTemplate导出sensoryReport" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", icon: "el-icon-search" },
                          on: { click: _vm.exportSensoryReport },
                        },
                        [_vm._v("导出")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "sensoryReport导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadSensoryReportUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "msv 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadMsvUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "line 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadLineUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "lint to product" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.lineToProductUrl,
                            headers: _vm.headers,
                            "http-request": _vm.reportDetailDocUpload,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "productFright导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.importProductFreightUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "feedback 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadFeedbackUrl,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物料报价申请单 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadProductApply,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "物料报价 导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadProductPrice,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "导出全部流程" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.exportWorkflow },
                        },
                        [_vm._v("导出全部流程")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "流程导入" } },
                    [
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            action: _vm.uploadActivitiWorkFlow,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "上传至服务器" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.fileType,
                          callback: function ($$v) {
                            _vm.fileType = $$v
                          },
                          expression: "fileType",
                        },
                      }),
                      _vm._v(" " + _vm._s(_vm.uploadRes) + " "),
                      _c(
                        "el-upload",
                        {
                          attrs: {
                            multiple: true,
                            "on-success": _vm.showRes,
                            action: _vm.uploadToDfs,
                            headers: _vm.headers,
                          },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                size: "small",
                                type: "primary",
                              },
                              slot: "trigger",
                            },
                            [_vm._v("选取文件")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c("el-card", [
                _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                  _c(
                    "p",
                    [
                      _vm._v(_vm._s(_vm.hostName) + "logs"),
                      _c("el-button", {
                        attrs: {
                          size: "mini",
                          type: "primary",
                          icon: "el-icon-refresh",
                          circle: "",
                        },
                        on: { click: _vm.reloadLogs },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", [
                  _c(
                    "ul",
                    _vm._l(_vm.logs, function (log) {
                      return _c(
                        "li",
                        [
                          _c(
                            "el-link",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.downloadLog(log.fileName)
                                },
                              },
                            },
                            [_vm._v(_vm._s(`${log.fileName}(${log.fileSize})`))]
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("el-row"),
      _c(
        "el-button",
        {
          attrs: { type: "primary", icon: "el-icon-search" },
          on: { click: _vm.exportPdf },
        },
        [_vm._v("Test")]
      ),
      _c(
        "el-button",
        { attrs: { type: "primary" }, on: { click: _vm.refreshCache } },
        [_vm._v("Refresh Cache")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }